/**
 * WalrusMinigame — the "Take bucket / Slap walrus / Leave alone" prompt
 * the legacy SWF spawned when /walrus fired (DefineSprite_436 frame 599).
 *
 *   ┌────────────────────────────────────────────────┐
 *   │ [Take bucket]                                  │
 *   │ [Slap walrus]    <walrus-with-bucket sprite>  │
 *   │ [Leave alone]                                  │
 *   └────────────────────────────────────────────────┘
 *
 * Local-only — each option triggers a client-side effect. No server
 * roundtrip; everyone in the room sees their own choice. This matches
 * the legacy behaviour where the menu was per-user (each saw their own).
 */
import { Modal } from './Modal.js';

export type WalrusChoice = 'bucket' | 'slap' | 'leave';

interface Props {
    onChoose: (c: WalrusChoice) => void;
}

export function WalrusMinigame({ onChoose }: Props) {
    return (
        <Modal title="🦭 the walrus is here!" onClose={() => onChoose('leave')}
               className="pc-modal-walrus" dismissOnBackdrop={false}>
            <div className="wm-grid">
                <div className="wm-buttons">
                    <button className="pw-btn wm-btn" onClick={() => onChoose('bucket')}>
                        Take bucket
                    </button>
                    <button className="pw-btn wm-btn" onClick={() => onChoose('slap')}>
                        Slap walrus
                    </button>
                    <button className="pw-btn wm-btn" onClick={() => onChoose('leave')}>
                        Leave alone
                    </button>
                </div>
                <img className="wm-img" src="/prochat/app/legacy/walrus-with-cookie.png" alt="walrus" />
            </div>
        </Modal>
    );
}
